import {FunctionFeature, SheetType} from '@mintdata/mint-kit/api/functions/SheetAPI';
import {PropName} from '@mintdata/mint-kit/api/properties/PropertySpec';
import {PropertyUtils} from '@mintdata/mint-kit/api/properties/PropertyUtils';
import {Type} from '@mintdata/mint-kit/api/types/Type';

export interface IFunctionSpec
{
    title?:string;
    tip?:string;
    icon?:string;
    alias?:string;
    example?:string;
    lazyOnly?:boolean;
    usesFeatures?:FunctionFeature[];
    returns?:IFunctionArgSpec;
}

export interface IFunctionArgSpec
{
    title?:string;
    tip?:string;
    type?:Type | SheetType;
    optional?:boolean;
    repeatable?:boolean;
}

export class FunctionSpec
{
    public title?:string;
    public tip?:string;
    public icon?:string;
    public alias?:string;
    public example?:string;
    public lazyOnly?:boolean;
    public returns?:IFunctionArgSpec;
    public usesFeatures:FunctionFeature[];
    public args:IFunctionArgSpec[] = [];

    public setValuesFrom(fs:IFunctionSpec)
    {
        this.title = fs.title;
        this.tip = fs.tip;
        this.icon = fs.icon;
        this.usesFeatures = fs.usesFeatures;
        this.returns = fs.returns;
        this.alias = fs.alias;
        this.example = fs.example;
        this.lazyOnly = fs.lazyOnly;
    }
}

export function Param(parameterSpec:IFunctionArgSpec):ParameterDecorator
{
    return function(target:Object, propName:PropName, parameterIndex:number)
    {
        const functionMap = PropertyUtils.getOrCreateFunctionMap(target);
        const functionSpec = functionMap.getOrCreateFunctionSpec(propName);

        functionSpec.args[parameterIndex] = parameterSpec;
    };
}

export function Function(spec?:IFunctionSpec):MethodDecorator
{
    return function(target:any, propName:PropName, propertyDescriptor?:PropertyDescriptor):void
    {
        const functionMap = PropertyUtils.getOrCreateFunctionMap(target);
        const functionSpec = functionMap.getOrCreateFunctionSpec(propName);

        functionSpec.setValuesFrom(spec);
    };
}
